'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('selectors/statistics');

var _statistics3 = require('helpers/statistics');

var _Panel = require('components/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _DevicesChart = require('components/Statistics/DevicesChart/DevicesChart');

var _DevicesChart2 = _interopRequireDefault(_DevicesChart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./DevicesStatistics.scss');

var DevicesStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadDevicesStats()).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    devicesData: (0, _statistics2.getDevicesData)(state, true),
    devicesStatsLoading: state.statistics.devicesStatsLoading,
    endDate: state.statistics.endDate,
    startDate: state.statistics.startDate
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DevicesStatistics, _Component);

  function DevicesStatistics() {
    (0, _classCallCheck3.default)(this, DevicesStatistics);
    return (0, _possibleConstructorReturn3.default)(this, (DevicesStatistics.__proto__ || (0, _getPrototypeOf2.default)(DevicesStatistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(DevicesStatistics, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      if (startDate !== this.props.startDate || endDate !== this.props.endDate) {
        if (startDate && endDate) {
          this.props.loadDevicesStats({ startDate: startDate, endDate: endDate });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          devicesData = _props.devicesData,
          devicesStatsLoading = _props.devicesStatsLoading;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Device Types') },
          _react2.default.createElement(_DevicesChart2.default, {
            loading: devicesStatsLoading,
            id: 'globalDevicesStats',
            data: devicesData.devices
          })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Source Types') },
          _react2.default.createElement(_DevicesChart2.default, {
            loading: devicesStatsLoading,
            id: 'globalSourcesStats',
            data: devicesData.sources,
            reverseColors: true
          })
        )
      );
    }
  }]);
  return DevicesStatistics;
}(_react.Component), _class2.propTypes = {
  devicesData: _propTypes2.default.object,
  devicesStatsLoading: _propTypes2.default.bool,
  endDate: _propTypes2.default.string,
  loadDevicesStats: _propTypes2.default.func,
  startDate: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  devicesData: _statistics3.defaultDevicesData,
  devicesStatsLoading: false
}, _temp)) || _class) || _class);
exports.default = DevicesStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/DevicesStatistics/DevicesStatistics.js
// module id = 2211
// module chunks = 1